import { render, staticRenderFns } from "./other-party-tab.vue?vue&type=template&id=b16b39d6&scoped=true&"
import script from "./other-party-tab.vue?vue&type=script&lang=js&"
export * from "./other-party-tab.vue?vue&type=script&lang=js&"
import style0 from "./other-party-tab.vue?vue&type=style&index=0&id=b16b39d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16b39d6",
  null
  
)

export default component.exports